import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import {
  CompanyInfoContext,
  CompanyInfoContextValue
} from '../context/CompanyInfoContext';
import CompanyDocumentEntry from './CompanyDocumentEntry';
import NewBadge from './NewBadge';
import { CompanyInfoSection } from './styled';

const CompanyPatent: React.FunctionComponent = () => {
  const { patentList } = useStyles();
  const context = useContext<CompanyInfoContextValue | null>(
    CompanyInfoContext
  );

  if (!context) return null;

  const { partnerInfo } = context;
  const patents = [...(partnerInfo?.patents ?? [])].reverse();
  const noPatents = patents.length === 0;

  if (noPatents) return null;

  return (
    <CompanyInfoSection id="patent">
      <div className="section-title new-column">
        <div className="new-column">
          <CustomizedTypography>특허</CustomizedTypography>
          <NewBadge />
        </div>
      </div>
      <div className={patentList}>
        {noPatents && (
          <CustomizedTypography className="no-data">
            업데이트 예정
          </CustomizedTypography>
        )}
        {patents.map((patent) => (
          <CompanyDocumentEntry certificate={patent} key={patent.id} />
        ))}
      </div>
    </CompanyInfoSection>
  );
};

export default CompanyPatent;

const useStyles = makeStyles((theme) => ({
  patentList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '16px',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'repeat(1, 1fr)'
    }
  }
}));
